import { render } from "./FinalTestingPage.vue?vue&type=template&id=64eccd9b&scoped=true"
import script from "./FinalTestingPage.vue?vue&type=script&lang=js"
export * from "./FinalTestingPage.vue?vue&type=script&lang=js"

import "./FinalTestingPage.vue?vue&type=style&index=0&id=64eccd9b&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64eccd9b"]])

export default __exports__